// extracted by mini-css-extract-plugin
export var dropdownButton = "_2u-0";
export var fullWidthDropdownButton = "_2u-1";
export var icon = "_2u-3";
export var iconPlaceholder = "_2u-2";
export var menuItemRow = "_2u-9";
export var separator = "_2u-e";
export var shortcutContainer = "_2u-7";
export var shortcutContainerFilled = "_2u-8";
export var shortcutIconLg = "_2u-6";
export var shortcutIconMd = "_2u-5";
export var shortcutIconSm = "_2u-4";
export var submenuChevron = "_2u-d";
export var submenuDropdown = "_2u-a";
export var submenuTriggerRow = "_2u-b";
export var submenuTriggerRowOpen = "_2u-c";